/* 🤖 this file was generated by svg-to-ts*/
import { qualitasIconBird } from './qualitasIcon-bird.icon';
import { qualitasIconCat } from './qualitasIcon-cat.icon';
import { qualitasIconCow } from './qualitasIcon-cow.icon';
import { qualitasIconDog } from './qualitasIcon-dog.icon';
import { qualitasIconGoat } from './qualitasIcon-goat.icon';
import { qualitasIconHamster } from './qualitasIcon-hamster.icon';
import { qualitasIconHorse } from './qualitasIcon-horse.icon';
import { qualitasIconMouse } from './qualitasIcon-mouse.icon';
import { qualitasIconMulti } from './qualitasIcon-multi.icon';
import { qualitasIconPig } from './qualitasIcon-pig.icon';
import { qualitasIconRabbit } from './qualitasIcon-rabbit.icon';
import { qualitasIconSheep } from './qualitasIcon-sheep.icon';
export const completeIconSet = [
  qualitasIconBird,
  qualitasIconCat,
  qualitasIconCow,
  qualitasIconDog,
  qualitasIconGoat,
  qualitasIconHamster,
  qualitasIconHorse,
  qualitasIconMouse,
  qualitasIconMulti,
  qualitasIconPig,
  qualitasIconRabbit,
  qualitasIconSheep
];
